module.exports = __webpack_public_path__ + "img/wz-7-1-1.a7b950b7.jpg";